export enum FlinkerDocumentType {
	QualificationDocuments = 'QualificationDocuments',
	IdDocument = 'IdDocuments',
	PassportDocument = 'PassportDocuments',
	Matric = 'Matric',
}
